import React, { useState } from 'react';
import axios from 'axios';
import { BACKEND_URL as API } from '../../apiConfig';
import shonanPalmLogo from '../../assets/shonan-palm-gold-transparent.png';

const InternalLogin = ({ onLogin }) => {
  const [isRegister, setIsRegister] = useState(false);
  const [form, setForm] = useState({ username: '', password: '', name: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      if (isRegister) {
        // 注册
        await axios.post(`${API}/api/internal/auth/register`, {
          username: form.username,
          password: form.password,
          name: form.name
        });
        setSuccess('注册成功！请等待管理员审核后登录。');
        setForm({ username: '', password: '', name: '' });
        setTimeout(() => {
          setIsRegister(false);
          setSuccess('');
        }, 3000);
      } else {
        // 登录
        const res = await axios.post(`${API}/api/internal/auth/login`, {
          username: form.username,
          password: form.password
        });
        localStorage.setItem('internal_token', res.data.token);
        localStorage.setItem('internal_user', JSON.stringify(res.data.user));
        onLogin(res.data.user);
      }
    } catch (err) {
      setError(err.response?.data?.detail || (isRegister ? '注册失败' : '登录失败'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="internal-alloy-shell flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-2xl border border-amber-300/30 bg-black/35 shadow-2xl shadow-amber-300/10 backdrop-blur-xl">
            <img
              src={shonanPalmLogo}
              alt="Shonan International"
              className="h-14 w-14 object-contain drop-shadow-[0_0_26px_rgba(216,183,105,0.62)]"
            />
          </div>
          <h1 className="font-serif text-2xl font-semibold tracking-[0.18em] text-[#f3d98b]">SHONAN</h1>
          <p className="mt-1 text-sm font-semibold tracking-[0.14em] text-slate-400">車隊管理システム</p>
        </div>

        {/* Login/Register Form */}
        <div className="rounded-2xl border border-amber-300/20 bg-black/35 p-8 shadow-2xl shadow-black/30 backdrop-blur-xl">
          <h2 className="text-white text-xl font-bold mb-6 text-center">
            {isRegister ? '用户注册' : '内部系统登录'}
          </h2>
          
          {error && (
            <div className="premium-chip-destructive rounded-lg p-4 mb-6">
              <p className="text-sm text-center">{error}</p>
            </div>
          )}

          {success && (
            <div className="inline-flex items-center rounded-lg premium-chip-success px-4 py-3 mb-6 w-full">
              <p className="text-sm text-center w-full">{success}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
                <label className="block text-slate-300 text-sm mb-2">用户名</label>
                <input
                  type="text"
                  value={form.username}
                  onChange={(e) => setForm({ ...form, username: e.target.value })}
                  className="premium-input"
                  placeholder="请输入用户名"
                  required
                  data-testid="internal-login-username"
                />
              </div>

            {isRegister && (
              <div>
                <label className="block text-slate-300 text-sm mb-2">姓名</label>
                <input
                  type="text"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="premium-input"
                  placeholder="请输入姓名"
                  required={isRegister}
                />
              </div>
            )}

            <div>
              <label className="block text-slate-300 text-sm mb-2">密码</label>
                <input
                  type="password"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  className="premium-input"
                  placeholder="请输入密码"
                  required
                  data-testid="internal-login-password"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full rounded-2xl border border-amber-300/35 bg-amber-300/20 px-4 py-3 font-semibold text-[#f3d98b] shadow-lg shadow-amber-300/10 transition-all hover:bg-amber-300/25 disabled:cursor-not-allowed disabled:opacity-60"
                data-testid="internal-login-submit"
              >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                  {isRegister ? '注册中...' : '登录中...'}
                </span>
              ) : (isRegister ? '注 册' : '登 录')}
            </button>
          </form>

          {/* Toggle Login/Register */}
          <div className="mt-6 text-center">
            <button
              onClick={() => {
                setIsRegister(!isRegister);
                setError('');
                setSuccess('');
                setForm({ username: '', password: '', name: '' });
              }}
              className="text-sm font-semibold text-[#f3d98b] hover:text-white"
            >
              {isRegister ? '已有账号？返回登录' : '没有账号？立即注册'}
            </button>
          </div>

          {isRegister && (
            <div className="mt-4 premium-chip-warning rounded-lg p-3">
              <p className="text-xs text-center">
                注册后需等待管理员审核通过才能登录
              </p>
            </div>
          )}
        </div>

        {/* Footer */}
        <p className="text-slate-500 text-xs text-center mt-6">
          © 2024 湘南国際株式会社 内部管理系统
        </p>
      </div>
    </div>
  );
};

export default InternalLogin;
